import { storeToRefs } from "pinia";
import { onBeforeUnmount } from "vue";
import { useEventsStore, type ScribeEventHandlers } from "@/stores/eventsStore";

export function useScribeSSE(options: ScribeEventHandlers = {}) {
	const eventsStore = useEventsStore();
	const removeHandlers = eventsStore.addHandlers(options);

	onBeforeUnmount(removeHandlers);

	const { isConnected, isConnecting, error } = storeToRefs(eventsStore);

	return {
		isConnected,
		isConnecting,
		error,
		connect: eventsStore.connect,
		disconnect: eventsStore.disconnect
	};
}
